import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import ProContactRow from './ProContactRow'
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../library/layout/Index";

const ProContact = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)
    else {
        return (
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span><FormTitle formObject={formObject} value="Available Contacts" /></span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} ksc="c" rowKey="" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Contact" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    {
                        Object.values(viewData).map((row, index) => (
                            <ProContactRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        ))
                    }
                </UiViewContent>
            </UiView>
        )
    }
}

export default withView(ProContact, "proContact", "proContact")